/* Cravinbyandy — subtle scroll reveal.
   Adds .is-in once an element scrolls into view. Intentionally light:
   one short fade+rise, runs once, never re-hides.

   FAIL-SAFE CONTRACT (see reveal.css):
   Elements are visible by default. Nothing is hidden until this file adds
   `reveal-ready` to <html>. If this file never runs, the page simply doesn't
   animate — it must never render blank. Keep the arming line first, and keep
   it out of any try/catch that could swallow a throw after it. */
(function () {
  var SELECTOR = '[data-reveal]';
  var root = document.documentElement;

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function init() {
    // Reduced motion / no IO support: never arm the hidden state at all.
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      root.classList.remove('reveal-ready');
      return;
    }

    // Arm hiding ONLY now that we know we can un-hide.
    root.classList.add('reveal-ready');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseFloat(el.getAttribute('data-reveal-delay') || '0');
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      // Anything already in view on load shows immediately (no flash of hidden hero).
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
        return;
      }
      io.observe(el);
    });

    // Safety net: if anything above silently failed to observe an element,
    // reveal everything after 3s rather than leaving content hidden forever.
    setTimeout(function () {
      document.querySelectorAll(SELECTOR + ':not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    if (root.classList.contains('reveal-ready')) revealAll();
    init();
  });

  // If a later script error kills the page, don't leave content invisible.
  window.addEventListener('error', function () {
    revealAll();
  });
})();
